import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CloseIcon,
  TedChatBubbleIcon,
} from '@g99-product-web-ui/shared-util-lib';

@Component({
  selector: 'g99-lib-ted-popup',
  templateUrl: './ted-popup.component.html',
  styleUrls: ['./ted-popup.component.scss'],
  standalone: false,
})
export class TedPopupComponent {
  @Input() public isOpen = false;
  @Output() public closed = new EventEmitter<void>();

  protected readonly tedIcon = TedChatBubbleIcon;
  protected readonly closeIcon = CloseIcon;

  protected onClose(): void {
    this.closed.emit();
  }

  protected onOverlayClick(): void {
    this.closed.emit();
  }
}
